import type { JSX } from "react";
import type { AspectRatio } from "@/types/roast";
import { cn } from "@/lib/utils";

const OPTIONS: AspectRatio[] = ["9:16", "16:9"];

export function AspectToggle({
  aspect,
  onChange,
}: {
  aspect: AspectRatio;
  onChange: (a: AspectRatio) => void;
}): JSX.Element {
  return (
    <div className="inline-flex rounded-full border border-border p-1">
      {OPTIONS.map((opt) => (
        <button
          key={opt}
          type="button"
          aria-pressed={aspect === opt}
          onClick={() => onChange(opt)}
          className={cn(
            "px-4 py-1.5 text-sm font-semibold rounded-full transition-colors",
            aspect === opt ? "bg-foreground text-background" : "text-muted-foreground",
          )}
        >
          {opt}
        </button>
      ))}
    </div>
  );
}
